import type {SearchParams} from 'typings/portaro.be.types';
import type {Writable} from 'svelte/store';
import type {SearchManager} from '../search-manager/search-manager';
import {getContext, hasContext, setContext} from 'svelte';
import {writable} from 'svelte/store';

const SEARCH_CONTEXT_KEY = 'search-context';
const SEARCH_CONTEXT_CONNECTOR_KEY = 'search-context-connector';

export function setSearchContext<ITEM>(searchManager: SearchManager<ITEM>) {
    setContext(SEARCH_CONTEXT_KEY, searchManager);
}

export function getSearchContext<ITEM, PARAMS extends SearchParams = SearchParams>(): SearchManager<ITEM, PARAMS> {
    const isInSearchContext = hasContext(SEARCH_CONTEXT_KEY);

    if (!isInSearchContext) {
        throw new Error('You need to use this component within KpSearchContext component');
    }

    return getContext(SEARCH_CONTEXT_KEY);
}

export function setupSearchContextConnector<ITEM>() {
    return setContext(SEARCH_CONTEXT_CONNECTOR_KEY, writable<SearchManager<ITEM> | undefined>());
}

export function getSearchContextConnector<ITEM, PARAMS extends SearchParams = SearchParams>(): undefined | Writable<undefined | SearchManager<ITEM, PARAMS>> {
    return getContext(SEARCH_CONTEXT_CONNECTOR_KEY);
}